import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Login() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('error'); // Default to error

    useEffect(() => {
        // Check if the user is already logged in
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        if (isLoggedIn) {
            navigate('/Home'); // Redirect to Home if already logged in
        }
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const username = data.get('username');
        const password = data.get('password');

        if (!username || !password) {
            setMessage('Please Enter Username and Password');
            setSeverity('error');
            setOpen(true);
            return;
        }

        if (
            (username === 'Admin' && password === '1234') ||
            (username === 'PrabhathK' && password === 'Munidasa123@')
        ) {
            // Save the login status in local storage
            localStorage.setItem('isLoggedIn', 'true');
            window.location.reload()
        } else {
            setMessage('Invalid Credentials');
            setSeverity('error');
            setOpen(true);
        }
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: "150px",
                minHeight: '100vh',
                padding: '20px',
            }}
        >
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                Login
            </Typography>

            <TextField
                label="User Name"
                name="username"
                variant="outlined"
                sx={{ marginBottom: '20px', width: '300px' }}
            />

            <TextField
                label="Password"
                name="password"
                type="password"
                variant="outlined"
                sx={{ marginBottom: '20px', width: '300px' }}
            />

            <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ width: '300px', padding: '10px' }}
            >
                Log In
            </Button>

            {/* Snackbar for error messages */}
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default Login;
